import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Necesito diagnóstico de SIBO para hacer el Protocolo?',
    a: 'No. Es para mujeres con síntomas compatibles (hinchazón, gases, fatiga). Si te dijeron "colon irritable" y seguís igual, es para vos.'
  }, {
    q: '¿Tengo que comprar productos importados o caros?',
    a: 'No. Todo está pensado para la feria y el súper argentino. El Bono 2 incluye 3 listas según tu presupuesto.'
  }, {
    q: '¿Cuánto tarda en funcionar?',
    a: 'La mayoría nota mejoría entre el Día 3 y 5. Al Día 14 el cambio suele ser significativo.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 14 días sin preguntas: si no es lo que esperabas, devolvemos el 100%. Tasa de devolución menor al 1%.'
  }, {
    q: '¿El producto es 100% digital?',
    a: 'Sí. Recibís el acceso inmediato en tu e-mail apenas se confirma el pago. El sistema completo está en formato PDF de alta calidad.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24 bg-brand-black" data-id="element-95">
      <div className="container mx-auto px-4" data-id="element-96">
        <div className="max-w-3xl mx-auto" data-id="element-97">
          <div className="text-center mb-12" data-id="element-98">
            <h2 className="text-3xl md:text-4xl font-bold font-[Poppins,_sans-serif]" data-id="element-99">
              ❓PREGUNTAS FRECUENTES
            </h2>
          </div>

          <div className="space-y-4" data-id="element-100">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="border border-gray-800 rounded-xl overflow-hidden bg-brand-dark" data-id="element-101">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-102">
                  <span className="font-bold text-lg text-white pr-8" data-id="element-103">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-brand-light shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-104" />
                </button>
                <AnimatePresence data-id="element-105">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-106">
                      <div className="p-6 pt-0 text-gray-300 leading-relaxed border-t border-gray-800/50 mt-2" data-id="element-107">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}